export enum ApplicationDateValidationFailureReason {
    SEASON_DATE_MISSING = 'SEASON_DATE_MISSING',
    TRAVEL_DATE_MISSING = 'TRAVEL_DATE_MISSING',
    TRAVEL_START_AFTER_END = 'TRAVEL_START_AFTER_END',
    TRAVEL_END_IN_FUTURE = 'TRAVEL_END_IN_FUTURE',
    TRAVEL_END_TOO_OLD = 'TRAVEL_END_TOO_OLD',
    TRAVEL_DURATION_TOO_SHORT = 'TRAVEL_DURATION_TOO_SHORT',
    SEASON_NOT_ACTIVE = 'SEASON_NOT_ACTIVE',
    TRAVEL_END_OUTSIDE_SEASON_RANGE = 'TRAVEL_END_OUTSIDE_SEASON_RANGE'
}
